import { Popover } from '@mui/material'
import { Icon, TailwindPopOver, Typography } from 'components'
import { Icons, OrganizationLinksProps, TypographyTypes } from 'interfaces'
import React, { useState } from 'react'

export const OrganizationLinks = (
	props: OrganizationLinksProps
): JSX.Element => {
	const { onCopyAAC, onCopyMoveOver, onCopySSO, organization } = props
	const links = [
		{
			id: 0,
			name: 'All Aboard',
			icon: Icons.train,
			onCopy: onCopyAAC,
			disabled: !organization.shareUrl
		},
		{
			id: 1,
			name: 'Move Over',
			icon: Icons.trolley,
			onCopy: onCopyMoveOver,
			disabled: !organization.branchUrlMigration
		},
		{
			id: 2,
			name: 'SSO',
			icon: Icons.key,
			onCopy: onCopySSO,
			disabled: !organization.branchUrlSso
		}
	]
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
	const open = Boolean(anchorEl)

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
		setAnchorEl(event.currentTarget)
	}
	const handleClose = (): void => {
		setAnchorEl(null)
	}

	return (
		<div>
			{!organization.shareUrl &&
			!organization.branchUrlMigration &&
			!organization.branchUrlSso ? (
				<div className="rounded-full border-2 border-blue-primary flex items-center justify-center w-[110px] px-1">
					<Typography
						title="Not set"
						fontLeading="15/18"
						type={TypographyTypes.span}
						className="font-normal text-blue-primary py-1 mr-1"
					/>

					<Icon
						fillPath
						src={Icons.cancel}
						className="text-blue-primary h-4 w-4 !min-h-3 !min-w-3"
					/>
				</div>
			) : (
				<button
					type="button"
					aria-label="org_type"
					onClick={handleClick}
					className="rounded-full border-2 border-blue-primary flex items-center justify-center w-[110px] px-1"
				>
					<Typography
						title="Get AAC"
						fontLeading="15/18"
						type={TypographyTypes.span}
						className="font-normal text-blue-primary py-1 mr-1"
					/>

					<Icon
						fillPath
						src={Icons.expandMore}
						className="text-blue-primary h-4 w-4 !min-h-3 !min-w-3"
					/>
				</button>
			)}
			<Popover
				id={open ? 'simple-popover' : undefined}
				open={Boolean(anchorEl)}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left'
				}}
				PaperProps={{ style: { borderRadius: '16px' } }}
			>
				<TailwindPopOver
					handleClose={handleClose}
					className="w-auto p-4 !gap-2 max-w-[210px] min-w-[115px]"
				>
					<div className="flex flex-col gap-4">
						{links
							.filter(link => !link.disabled)
							.map((link, index) => (
								<button
									key={index}
									type="button"
									aria-label="org_type"
									className="flex items-center justify-start gap-2"
									onClick={() => link.onCopy()}
								>
									<Icon
										fillPath
										src={link.icon}
										className="text-blue-primary h-4 w-4 "
									/>

									<Typography
										className="font-normal"
										title={link.name}
										fontLeading="14/24"
										type={TypographyTypes.span}
									/>
								</button>
							))}
					</div>
				</TailwindPopOver>
			</Popover>
		</div>
	)
}
